/**
 * useRegisterCommands
 *
 * Registers a set of command palette entries for the lifetime of the calling
 * component (register on mount, unregister on unmount). Pass a MEMOIZED `entries`
 * array — its identity is the effect dependency, so an unstable array would
 * re-register every render. Re-memoizing with fresh handler closures when inputs
 * change correctly replaces the previous registration.
 */

import { useEffect } from 'react';
import { commandRegistryActions } from './commandRegistryStore';
import type { CommandDescriptor } from './keybinding.types';

export function useRegisterCommands(
  entries: { descriptor: CommandDescriptor; run: () => void }[]
): void {
  useEffect(() => commandRegistryActions.register(entries), [entries]);
}
